import { render, staticRenderFns } from "./UpdateUserPassword.vue?vue&type=template&id=a740271e"
import script from "./UpdateUserPassword.vue?vue&type=script&lang=ts"
export * from "./UpdateUserPassword.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports